export default {
  GET_PREMIUM_INFO: 'VOD.PREMIUM.GET_PREMIUM_INFO',
  GET_USAGE: 'VOD.PREMIUM.GET_USAGE',
};



// WEBPACK FOOTER //
// ./src/transport/adapters/vod/events/types/premium.js